import type { mountChart } from './echarts-runtime';
export type ChartRuntime = { mountChart: typeof mountChart };
let pending: Promise<ChartRuntime> | undefined;
export function loadChartRuntime(): Promise<ChartRuntime> {
  // The build emits this independent entry for web/mobile/dev. Keeping the URL
  // dynamic prevents the main single-file bundle from inlining ECharts.
  const url = new URL('./echarts-runtime.js', import.meta.url).href;
  return (pending ??= import(url).catch((error) => {
    pending = undefined;
    throw error;
  }));
}
